import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Headers } from '@angular/http';

import { MainService } from 'app/resources/services/index';
import { DefineBootboxId, EnderecoResidencial } from 'app/resources/classes';
import 'bootbox';

@Component({
  selector: 'app-cesta',
  templateUrl: './cesta.component.html'
})

export class CestaComponent implements OnInit {

  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();
  public processandoCalcularFrete: boolean;
  public processando: boolean;
  public valePresente: any = undefined;
  public itens: Array<any> = undefined;
  public totalItens = undefined;
  public valorTotal = undefined;
  public pontosTotais = undefined;
  public pedido: any;
  public quantidade;
  public cep: string;
  public fretes = undefined;
  public ep: string;
  public logradouroIsReadOnly: boolean;
  public bairroIsReadOnly: boolean;
  public pedidoComValeFisico: boolean;

  constructor(public mainService: MainService, public router: Router) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.processando = false;
    this.quantidade = 1;
    this.cep = '';
    this.ep = '';
    this.logradouroIsReadOnly = true;
    this.pedidoComValeFisico = false;
    this.bairroIsReadOnly = true;
    this.itens = this.mainService.valePresenteCestaService.itens;
    this.limpaPedido();
    this.mainService.saldoService.initialize();
    this.verificarValeFisico();
    this.calculaTotais();

  }

  private limpaPedido() {
    this.pedido = {
      frete: {
        valor: undefined,
        pontos: undefined
      },
      endereco: {
        logradouro: undefined,
        numero: undefined,
        complemento: undefined,
        bairro: undefined,
        cidade: undefined,
        uf: undefined
      }
    };
  }

  setEndereco(item) {
    this.pedido.frete = item;
  }

  public calculaTotais() {
    this.itens = this.mainService.valePresenteCestaService.itens;
    this.totalItens = this.mainService.valePresenteCestaService.totalItens();
    this.valorTotal = this.mainService.valePresenteCestaService.valorTotal();
    this.pontosTotais = this.mainService.valePresenteCestaService.pontosTotais();
  }

  public setFretes() {
    this.mainService.http.pathRest().get('enum/correios/fretes/' + this.pedido.endereco.cep + '/')
      .subscribe(
        sucesso => {
          this.fretes = sucesso.json();
        }, erro => {
        });
    this.processandoCalcularFrete = false;
  }

  public showItemError(item) {
    this.bootboxAlertComId.alerta(item.invalidMessage);
  }

  public remove(valePresente) {
    const mensagem = bootbox.confirm({
      message: 'Deseja remover este item da cesta?',
      buttons: {
        confirm: {
          label: 'Sim',
          className: 'app-btn-best'
        },
        cancel: {
          label: 'Não',
          className: 'btn-default'
        }
      }, callback: (result) => {
        if (result) {
          const retorno = this.mainService.valePresenteCestaService.remove(valePresente);
          if (!retorno) {
            this.verificarValeFisico();
            this.limpaPedido();
          }
          this.calculaTotais();
          ;
        }
      }
    });
    mensagem.on('shown.bs.modal', function () {
      $('button[data-bb-handler="cancel"]').attr('id', 'btn-bootbox-cancel');
      $('button[data-bb-handler="confirm"]').attr('id', 'btn-bootbox-confirm');
      $('button[class="bootbox-close-button close"]').attr('id', 'btn-bootbox-close');
      $('div[class="bootbox-body"]').attr('id', 'div-bootbox-body');
    });
  }

  public verificarValeFisico() {
    const itens = this.mainService.valePresenteCestaService.itens;
    this.pedidoComValeFisico = false;
    for (let i = 0; i < itens.length; i++) {
      if (!itens[i].valePresente.virtual) {
        this.pedidoComValeFisico = true;
        break;
      }
    }
  }

  public validarCesta() {
    this.mainService.valePresenteCestaService.validate();
    this.calculaTotais();
    this.verificarValeFisico();
    if (this.mainService.sessionService.clienteValePresenteFreteGratuito ||
      !this.pedidoComValeFisico) {
      this.calcularFrete();
    }
  }

  public save() {
    if (!this.mainService.sessionService.clienteValePresenteFreteGratuito &&
      !this.pedido.destinatario && this.pedidoComValeFisico) {
      this.bootboxAlertComId.alerta('Digite o nome do Destinatário!');
    } else if (!this.ep) {
      this.bootboxAlertComId.alerta('Digite a senha eletrônica!');
    } else {
      this.processando = true;
      this.pedido.itens = this.mainService.valePresenteCestaService.itens;
      const header: Headers = new Headers();
      header.append('Authorization', 'Basic ' + this.mainService.sessionService.getAuthBasic());
      header.append('X-Auth-Ep', this.ep);
      this.mainService.http.pathRest().post('valepresente/pedidos/', this.pedido, true, header)
        .subscribe(
          sucesso => {
            this.mainService.saldoService.initialize();
            this.mainService.valePresenteCestaService.clean();
            this.router.navigate(['/valepresente']);
            this.processando = false;
            this.bootboxAlertComId.alerta('O pedido de vale presente foi realizado com sucesso!');
          }, (erro) => {
            this.processando = false;
            this.bootboxAlertComId.alerta(erro._body);
          }
        );
    }
  }

  public calcularFrete() {

    if (this.mainService.sessionService.clienteValePresenteFreteGratuito
      || !this.pedidoComValeFisico) {
      this.pedido = { frete: { valor: 0, pontos: 0 } };
    } else if (this.cep && this.cep.length === 8) {
      this.processandoCalcularFrete = true;
      this.limpaPedido();
      this.fretes = undefined;

      this.mainService.cepService.findByViaCep(this.cep)
        .subscribe(
          sucesso => {
            sucesso = sucesso.json();
            this.pedido.endereco = new EnderecoResidencial({
              bairro: sucesso.bairro,
              cep: this.cep,
              cidade: sucesso.localidade,
              logradouro: sucesso.logradouro,
              numero: '',
              uf: sucesso.uf,
              complemento: ''
            });

            this.logradouroIsReadOnly = !this.pedido.endereco || !this.pedido.endereco.cidade || this.pedido.endereco.logradouro;
            this.bairroIsReadOnly = !this.pedido.endereco || !this.pedido.endereco.cidade || this.pedido.endereco.bairro;

            this.mainService.http.pathRest().get('enum/correios/fretes/' + this.pedido.endereco.cep + '/', true)
              .subscribe(
                data => {
                  this.fretes = data.json();
                  this.processandoCalcularFrete = false;
                }, erro => {
                  this.bootboxAlertComId.alerta(erro._body);
                  this.processandoCalcularFrete = false;
                });
          }, erro => {
            this.bootboxAlertComId.alerta(erro._body);
            this.processandoCalcularFrete = false;
          });
    } else {
      this.bootboxAlertComId.alerta('O CEP deve conter 8 caracteres numéricos!');
    }
  }

  public clean() {
    if (this.cep === undefined || this.cep === '') {
      if (this.pedido) {
        delete this.pedido.endereco;
        delete this.pedido.frete;
      }
      if (this.fretes) {
        delete this.fretes;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/vale-presente/cesta/cesta.component.ts